export const INIT = 'TYPEAHEAD_INIT';
export const UPDATE_OPTIONS = 'TYPEAHEAD_UPDATE_OPTIONS';
export const UPDATE_SELECTED = 'TYPEAHEAD_UPDATE_SELECTED';
